/* eslint-disable react-refresh/only-export-components */
import {
  GameRegistry,
  GameConfig,
  GameComponentProps,
} from '../../frontend/components/game';
import { AlienAttackGame } from './AlienAttackGame';

const alienAttackConfig: GameConfig = {
  id: 'alienAttack',
  title: 'AlienAttack',
  description:
    'Blast alien invaders as they swoop down from formation! The classic 1979 arcade shooter with diving enemies.',
  category: 'retro',
  tier: 'free',
  multiplayer: false,
  controls: {
    keyboard: ['← → to move', 'SPACE to fire', 'P to pause'],
    mouse: false,
    touch: true,
  },
  difficulty: 'medium',
  estimatedPlayTime: '5-15 min',
};

// Wrapper to match GameComponentProps interface
function AlienAttackWrapper(props: GameComponentProps) {
  return (
    <AlienAttackGame
      onScoreChange={props.onScoreChange}
      onGameOver={props.onGameOver}
    />
  );
}

// Register the game
GameRegistry.register({
  config: alienAttackConfig,
  component: AlienAttackWrapper,
});

export { AlienAttackGame };
export { AlienAttackScene } from './AlienAttackScene';
export { alienAttackConfig };
